import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentAdapter } from 'app/core/adapters/payment.adapter';
import { Payment, PaymentAPIResponse } from 'app/core/interfaces/payment';
import { environment } from 'app/environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(
    private http: HttpClient,
    private paymentAdapter: PaymentAdapter,
  ) {}

  public create(payment: Payment): Observable<Payment> {
    const paymentAPI = this.buildCreatePaymentPayload(payment);

    return this.http
      .post<PaymentAPIResponse>(`${environment.apiUrl}/secretarias-payment`, paymentAPI)
      .pipe(map((paymentAPI: PaymentAPIResponse) => this.paymentAdapter.adapterToModel(paymentAPI)));
  }

  public confirmPayment(payment_id: string, params: any) {
    return this.http.put<PaymentAPIResponse>(`${environment.apiUrl}/secretarias-payment/${payment_id}/confirm-payment`, params).pipe(
      map((paymentAPI: PaymentAPIResponse) => {
        const adaptedPayment = this.paymentAdapter.adapterToModel(paymentAPI);
        return adaptedPayment;
      }),
    );
  }

  public verifyAttendanceCode(payment_id: string, code: string): Observable<Payment> {
    return this.http
      .post<PaymentAPIResponse>(`${environment.apiUrl}/secretarias-payment/${payment_id}/verify-attendance-code`, { code })
      .pipe(map((paymentAPI: PaymentAPIResponse) => this.paymentAdapter.adapterToModel(paymentAPI)));
  }

  public show(payment_id: string): Observable<Payment> {
    return this.http
      .get<PaymentAPIResponse>(`${environment.apiUrl}/secretarias-payment/${payment_id}`)
      .pipe(map((paymentAPI: PaymentAPIResponse) => this.paymentAdapter.adapterToModel(paymentAPI)));
  }

  public listByEncounter(encounter_id: string): Observable<Payment> {
    return this.http
      .get<PaymentAPIResponse>(`${environment.apiUrl}/secretarias-payment/encounters/${encounter_id}`)
      .pipe(map((paymentAPI: PaymentAPIResponse) => this.paymentAdapter.adapterToModel(paymentAPI)));
  }

  private buildCreatePaymentPayload(payment: Payment): PaymentAPIResponse {
    const paymentMethod = payment.payment_method || payment.billingType;

    if (payment.encounter_id && paymentMethod) {
      const payload: PaymentAPIResponse = {
        encounter_id: payment.encounter_id,
        payment_method: paymentMethod,
        customer_info: payment.customer_info,
        confirmed_by: payment.confirmed_by,
      };

      if (payment.card_token) {
        payload.card_token = payment.card_token;
      }

      if (payment.card_id) {
        payload.card_id = payment.card_id;
      }

      if (payment.installments) {
        payload.installments = payment.installments;
      }

      if (payment.credit_card) {
        payload.credit_card = payment.credit_card;
      }

      if (payment.force_new) {
        payload.force_new = true;
      }

      return payload;
    }

    return this.paymentAdapter.adaptToAPIFormat(payment);
  }
}
